import { Button } from "@/atoms"
import { CloseOutlined } from "@/icons"

import styles from "./RemoveButton.module.scss"

import type { RemoveButtonProps } from "."

export const RemoveButton = (props: RemoveButtonProps) => {
  const { name, remove, onClick = remove, ...rest } = props

  return (
    <Button
      block
      className={styles.button}
      type="text"
      onClick={onClick}
      icon={<CloseOutlined />}
      data-testid={`${name}_remove_button`}
      {...rest}
    />
  )
}
